<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Mutasi Produk</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<v-col cols="12" class="px-4">
					<v-row>
						<v-col cols="4" md="3">
							<v-text-field outlined dense hide-details label="Nama Produk" v-model="name.value"></v-text-field>
						</v-col>
						<v-col cols="4" md="3">
							<v-text-field outlined dense hide-details label="Kode Produk" v-model="code.value"></v-text-field>
						</v-col>
            <v-col cols="4" md="3">
              <v-menu v-model="mutationdate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field outlined dense :value="convertDate(mutationproductdate)" label="Tanggal Mutasi" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
                </template>
                <v-date-picker range color="primary" v-model="mutationproductdate"></v-date-picker>
              </v-menu>
            </v-col>
						<v-col cols="12" md="12" class="text-right">
							<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
							<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
						</v-col>
					</v-row>
				</v-col>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading :headers="headers" :items="listStock" hide-default-footer :options.sync="option" :server-items-length="listStock.total_data" disable-pagination class="table-w-140">
				<template v-slot:item.product_stock_log_datetime="{ item }">
					<div>{{ item.product_stock_log_datetime | tanggalid }}</div>
				</template>
				<template v-slot:item.product_name="{ item }">
					<div>{{ item.product_name }}</div>
				</template>
				<template v-slot:item.product_code="{ item }">
					<div>{{ item.product_code }}</div>
				</template>
				<template v-slot:item.product_stock_log_in_value="{ item }">
					<div>{{ item.product_stock_log_in_value }}</div>
				</template>
				<template v-slot:item.product_stock_log_out_value="{ item }">
					<div>{{ item.product_stock_log_out_value }}</div>
				</template>
				<template v-slot:item.product_stock_log_last_value="{ item }">
					<div>{{ item.product_stock_log_last_value }}</div>
				</template>
				<template v-slot:item.product_stock_log_note="{ item }">
					<div>{{ item.product_stock_log_note }}</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!stockPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="stockPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="stockPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState,} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
      mutationdate: false,
      mutationproductdate: [],
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			headers: [
			{ text: 'Tanggal', value: 'product_stock_log_datetime'},
			{ text: 'Nama Produk', align: 'start', value: 'product_name'},
			{ text: 'Kode Produk', align: 'start', value: 'product_code'},
			{ text: 'Masuk', value: 'product_stock_log_in_value'},
			{ text: 'Keluar', value: 'product_stock_log_out_value'},
			{ text: 'Stok Terakhir', value: 'product_stock_log_last_value'},
			{ text: 'Keterangan', value: 'product_stock_log_note'},
			],
			mutation_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'product_stock_log_datetime'
			},
			code: {
				value:'',
				comparison:'like',
				type:'string',
				field:'product_code'
			},
			name: {
				value:'',
				comparison:'like',
				type:'string',
				field:'product_name'
			},
			params:[],
		}
	},
	computed: {
		...mapState('stock', ['listStock', 'stockPagination']),
	},
	methods: {
		...mapActions('stock', ['getStockLog', 'exportStockLog']),

		getData() {
			this.getStockLog(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		exportData(){
			this.exportStockLog(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		cari() {
			this.params= []

      if (this.mutation_date.value){
				if (this.mutation_date.value.length > 1) {
					this.mutation_date.value.sort()
					let date = this.mutation_date.value.join('::')
					this.mutation_date.value = date
				}
        this.params.push(Object.assign({}, this.mutation_date))
			}

			if(this.code.value)
				this.params.push(this.code)

			if(this.name.value)
				this.params.push(this.name)

			this.getData()
		},
		resetFilter() {
			this.code.value = ''
			this.name.value = ''
      this.mutationproductdate = []
			this.params = []
			this.limit = 10
			this.getData()
		},
	},
	created() {
		this.getData()
		this.$store.dispatch('setPageTitle', `Mutasi Produk`)
	},
	watch: {
		mutationproductdate(val) {
			this.mutation_date.value = val
		},
		page() {
			this.getData()
		},
		limit() {
			this.getData()
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>
